/* tslint:disable */
/* eslint-disable */
import type { PaxCheckApplyManualDocumentResult } from './PaxCheckApplyManualDocumentResult';
import {
    PaxCheckApplyManualDocumentResultFromJSON,
    PaxCheckApplyManualDocumentResultToJSON,
} from './PaxCheckApplyManualDocumentResult';
import type { PaxCheckApplyTravelDocumentResponseError } from './PaxCheckApplyTravelDocumentResponseError';
import {
    PaxCheckApplyTravelDocumentResponseErrorFromJSON,
    PaxCheckApplyTravelDocumentResponseErrorToJSON,
} from './PaxCheckApplyTravelDocumentResponseError';

export interface PaxCheckApplyManualDocumentResponse {
    data?: PaxCheckApplyManualDocumentResult;
    error?: PaxCheckApplyTravelDocumentResponseError;
}

export function instanceOfPaxCheckApplyManualDocumentResponse(value: object): value is PaxCheckApplyManualDocumentResponse {
    return true;
}

export function PaxCheckApplyManualDocumentResponseFromJSON(json: any): PaxCheckApplyManualDocumentResponse {
    return PaxCheckApplyManualDocumentResponseFromJSONTyped(json, false);
}

export function PaxCheckApplyManualDocumentResponseFromJSONTyped(json: any, _ignoreDiscriminator: boolean): PaxCheckApplyManualDocumentResponse {
    if (json == null) return json;
    return {
        data: json['data'] == null ? undefined : PaxCheckApplyManualDocumentResultFromJSON(json['data']),
        error: json['error'] == null ? undefined : PaxCheckApplyTravelDocumentResponseErrorFromJSON(json['error']),
    };
}

export function PaxCheckApplyManualDocumentResponseToJSON(value?: PaxCheckApplyManualDocumentResponse | null): any {
    if (value == null) return value;
    return {
        data: PaxCheckApplyManualDocumentResultToJSON(value.data),
        error: PaxCheckApplyTravelDocumentResponseErrorToJSON(value.error),
    };
}
